export enum TemplateModalMode {
	view = "view",
	edit = "edit",
	add = "add"
}
